import { cx } from "cva";
import { Body, Headline } from "~/ui-library";

export interface UnknownBlockTypeProps {
  block?: unknown;
  /** Class name that is attached to the code block displaying the error */
  className?: string;
}

export const UnknownBlockType = ({
  block,
  className,
}: UnknownBlockTypeProps): JSX.Element => (
  <div className="bg-danger-200/20 p-3">
    <div className="flex flex-col gap-4 rounded border-1 border-danger-800 p-12">
      <Headline level={2} as="h2" className="text-danger-900">
        Invalid Block
      </Headline>
      <Body className="text-danger-900">
        The block is not recognized by the client. This probably means that
        there is a mismatch between versions of the CMS and the client.
      </Body>
      <pre
        className={cx(
          "rounded bg-danger-200/30 p-6 text-danger-900",
          className
        )}
      >
        <code>{JSON.stringify(block, null, 2)}</code>
      </pre>
    </div>
  </div>
);
